if (!customElements.get('hxz-sets-customize')) {
  customElements.define('hxz-sets-customize', class HXZSetsCustomize extends HTMLElement {
    constructor() {
      super();
      this.blockSingles = this.querySelectorAll('.hxz-customize-block');
      this.blockSingles.forEach(block => {
        block.addEventListener('click', this.onVariantClick.bind(this));
      })
    }

    getSelectedDatas() {
      let items = []
      let itemsDisplay = ''
      const requiredBlocks = this.querySelectorAll(
        '.hxz-customize-block[data-required="true"]'
      )
      const valid = Array.from(requiredBlocks).every(block =>
        block.querySelector('.selected[data-sku-available="true"]')
      )

      this.querySelectorAll('.hxz-customize-block .selected').forEach(block => {
        items.push(block.dataset.skuId)
        itemsDisplay += block.closest('.hxz-customize-block').dataset.productNickname + '-' + block.closest('.hxz-customize-block').dataset.productSkuTitle + '|';
      })
      return {
        items: items,
        nameDispaly: itemsDisplay,
        valid: valid
      }
    }

    notifyAvailabilityChange() {
      this.dispatchEvent(
        new CustomEvent('customize:availability-change', {
          bubbles: true,
          detail: {
            available: this.getSelectedDatas().valid
          }
        })
      )
    }

    clearSelected(dom) {
      for (const child of dom.parentNode.children) {
        child.classList.remove('selected')
      }
    }

    onVariantClick(event) {
      event.preventDefault();
      const selected = event.target.closest('.hxz-customize-sku')
      if (selected && selected.dataset.skuAvailable === 'true') {
        this.clearSelected(selected)
        selected.classList.add('selected')
        selected.closest('.hxz-customize-block').querySelector('img').src = selected.dataset.skuImage
        selected.closest('.hxz-customize-block').querySelector('.hxz-customize-variant-desc').innerText = selected.dataset.skuDesc
        selected.closest('.hxz-customize-block').dataset.productSkuTitle = selected.dataset.skuName
        selected.closest('.hxz-customize-block').dataset.skuId = selected.dataset.skuId
        this.notifyAvailabilityChange()
      }
    }

    connectedCallback() {
      this.notifyAvailabilityChange()
    }

    disconnectedCallback() {
    }

  });
}
